var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"singularity-canvas-add-another-button",on:{"click":_vm.addAnother}},[_c('div',{staticClass:"singularity-canvas-add-another-button__inner"},[_c('Icon',{attrs:{"icon":"PlusIconSolid","size":"14"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }